import { PurchaseSuccessScreen } from "@/app/modules/Purchases/PurchaseSuccessScreen.tsx";

export const PurchaseSuccess = () => {
  return <PurchaseSuccessScreen />;
};
